var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 17.455,
    viewBox: "0 0 24 17.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M40-782.545V-785.6a3.2,3.2,0,0,1,.477-1.7,3.181,3.181,0,0,1,1.268-1.186,16.194,16.194,0,0,1,3.436-1.268,15.007,15.007,0,0,1,3.545-.423,15.007,15.007,0,0,1,3.545.423,16.194,16.194,0,0,1,3.436,1.268,3.181,3.181,0,0,1,1.268,1.186,3.2,3.2,0,0,1,.477,1.7v3.055Zm19.636,0v-3.273a4.389,4.389,0,0,0-.668-2.3,5.894,5.894,0,0,0-1.9-1.9,13.764,13.764,0,0,1,2.618.559,13.647,13.647,0,0,1,2.291.968,4.832,4.832,0,0,1,1.5,1.214A2.33,2.33,0,0,1,64-785.818v3.273Zm-10.909-8.727a4.2,4.2,0,0,1-3.082-1.282,4.2,4.2,0,0,1-1.282-3.082,4.2,4.2,0,0,1,1.282-3.082A4.2,4.2,0,0,1,48.727-800a4.2,4.2,0,0,1,3.082,1.282,4.2,4.2,0,0,1,1.282,3.082,4.2,4.2,0,0,1-1.282,3.082A4.2,4.2,0,0,1,48.727-791.273Zm10.909-4.364a4.2,4.2,0,0,1-1.282,3.082,4.2,4.2,0,0,1-3.082,1.282,5.445,5.445,0,0,1-.764-.068,6.678,6.678,0,0,1-.764-.15,6.488,6.488,0,0,0,1.132-1.936,6.289,6.289,0,0,0,.4-2.209,6.288,6.288,0,0,0-.4-2.209,6.488,6.488,0,0,0-1.132-1.936,3.318,3.318,0,0,1,.764-.177,7.16,7.16,0,0,1,.764-.041,4.2,4.2,0,0,1,3.082,1.282A4.2,4.2,0,0,1,59.636-795.636Z",
    transform: "translate(-40 800)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersLightIcon);
export default __webpack_public_path__ + "static/media/users_light_icon.ee7dc7ebf0ce370468da9c216b377fe6.svg";
export { ForwardRef as ReactComponent };